/* index.js */

"use strict";

module.exports = {
    Grid: require('./src/GridComponent'),
    DefaultColumnComponent: require('./src/column_renderer/default/DefaultColumnComponent')
};
